import React, { useState, useEffect } from "react";
import AnimatedElement from "./AnimatedElement";
import { useTranslation } from "react-i18next";

export const Contact = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    nome: "",
    telefone: "",
    email: "",
    interesse: "",
    mensagem: "",
  });

  // Limpa o formulário ao montar o componente
  useEffect(() => {
    setForm({
      nome: "",
      telefone: "",
      email: "",
      interesse: "",
      mensagem: "",
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/contact/send-contact`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        }
      );
      if (response.ok) {
        alert(t("contact.alert.success"));
        setForm({
          nome: "",
          telefone: "",
          email: "",
          interesse: "",
          mensagem: "",
        });
      } else {
        alert(t("contact.alert.error.submit"));
      }
    } catch (error) {
      alert(t("contact.alert.error.generic"));
    }
  };

  return (
    <section id="solicite" className="solicite-reuniao">
      <div className="container">
        <div className="solicite-content">
          <AnimatedElement animation="fade-right" className="solicite-text">
            <h2>{t("contact.title")}</h2>
            <p>{t("contact.subtitle")}</p>
            <div className="solicite-benefits">
              <AnimatedElement
                animation="fade-up"
                delay={200}
                className="benefit-item"
              >
                <span className="benefit-icon">✓</span>
                <span>{t("contact.benefit1")}</span>
              </AnimatedElement>
              <AnimatedElement
                animation="fade-up"
                delay={400}
                className="benefit-item"
              >
                <span className="benefit-icon">✓</span>
                <span>{t("contact.benefit2")}</span>
              </AnimatedElement>
              <AnimatedElement
                animation="fade-up"
                delay={600}
                className="benefit-item"
              >
                <span className="benefit-icon">✓</span>
                <span>{t("contact.benefit3")}</span>
              </AnimatedElement>
            </div>
          </AnimatedElement>
          <AnimatedElement
            animation="fade-left"
            className="solicite-form-container"
          >
            <div className="solicite-form">
              <h3>{t("contact.form.title")}</h3>
              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="form-row">
                  <input
                    type="text"
                    name="nome"
                    placeholder={t("contact.form.placeholder.name")}
                    required
                    value={form.nome}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-row">
                  <input
                    type="tel"
                    name="telefone"
                    placeholder={t("contact.form.placeholder.phone")}
                    required
                    value={form.telefone}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-row">
                  <input
                    type="email"
                    name="email"
                    placeholder={t("contact.form.placeholder.email")}
                    required
                    value={form.email}
                    onChange={handleChange}
                  />
                </div>

                <select
                  name="interesse"
                  required
                  value={form.interesse}
                  onChange={handleChange}
                >
                  <option value="" disabled hidden>
                    {" "}
                    {t("contact.form.interest.placeholder")}
                  </option>
                  <option value="rha">
                    {t("contact.form.interest.option1")}
                  </option>
                  <option value="csap">
                    {t("contact.form.interest.option2")}
                  </option>
                  <option value="ambos">
                    {t("contact.form.interest.option3")}
                  </option>
                </select>
                <textarea
                  name="mensagem"
                  placeholder={t("contact.form.placeholder.message")}
                  rows="3"
                  value={form.mensagem}
                  onChange={handleChange}
                ></textarea>
                <button type="submit" className="form-submit-btn">
                  {t("contact.form.submitButton")}
                </button>
              </form>
            </div>
          </AnimatedElement>
        </div>
      </div>
    </section>
  );
};
